module.exports = __webpack_public_path__ + "img/renegades-le_mclaren.4a15817.png";